import { Component, Input } from '@angular/core';
import { LaunchpadUser } from '../models/launchpad-user';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-user-slideout',
    templateUrl: './user-slideout.component.html',
    styleUrls: ['./user-slideout.component.sass'],
    standalone: false
})
export class UserSlideoutComponent {
  @Input() loading: boolean = true;
  @Input() user: LaunchpadUser | null = null;

  constructor(protected activeSlideout: NgbActiveOffcanvas) { }
}
